import 'jquery.scrollbar';
import 'chosen-js';
import 'eonasdan-bootstrap-datetimepicker';
import 'spectrum-colorpicker';
import 'jquery-tags-input';
import './libs/prettyCheckable.min';
import './libs/sortable.min';
import dropzone from 'dropzone';

export const plugins = {
    init: function() {
        plugins.scrollbarInit();
        plugins.chosenInit();
        plugins.pickDate();
        plugins.pickColor();
        plugins.dropzoneInit();
        plugins.checkboxStyle();
        plugins.sortableModules();
        plugins.tabsInputInit();
    },
    scrollbarInit: function() {
        $('.scrollbar').scrollbar();
    },
    chosenInit: function() {
        $('.chosen-select, .entries select').chosen({
            disable_search_threshold: 10
        });
    },
    pickDate: function() {
        const input = $('.datepicker');
        input.each(function() {
            const self = $(this);
            const par = self.parents('fieldset');
            const nest = par.find('.picker-nest');
            self.datetimepicker({
                widgetParent: nest
            });
        });
    },
    pickColor: function() {
        const input = $('.picker')
        input.each(function() {
            const self = $(this);
            const par = self.parents('fieldset');
            self.spectrum({
                showInput: true,
                show: function(color) {
                    const picker = $('.sp-container');
                    picker.find('.sp-input').val(color.toHexString());
                },
                move: function(color) {
                    const picker = $('.sp-container');
                    picker.find('.sp-input').val(color.toHexString());
                },
                change: function(color) {
                    par.find('.sp-replacer').html(color.toHexString());
                }
            });
        });
    },
    dropzoneInit: function() {
        dropzone.autoDiscover = false;
        const upload = $('.dropzone');
        upload.each(function() {
            const self = $(this);
            const url = self.data('url');
            self.dropzone({
                url: url,
                addRemoveLinks: true
            });
        });
    },
    checkboxStyle: () => {
        $('input[type="checkbox"], input[type="radio"]').each(function() {
            $(this).prettyCheckable();
        });
    },
    sortableModules: function() {
        const list = $('.sortable');
        const gallery = $('.sortable-images');
        list.each(function() {
            const self = $(this);
            self.sortable();
        });
        gallery.each(function() {
            const self = $(this);
            self.sortable();
        });
    },
    tabsInputInit: function() {
        $('.keywords').tagsInput({
            defaultText: 'Add an entry',
            height: false,
            width: false
        });
    }
}